import styled from 'styled-components';
import { StyledModal } from '../../../common/shared/modal.styled';

export const BankAdjustmentsWrapper = styled.div`
    border-radius: 28px; 
    border: 1px solid ${props => props.theme.borderLight};
    padding: 20px;
    margin-top: 25px;
    min-height: 600px;

    .report-top {
      margin: 0 !important;
    }

    .bank_adjustments_header {
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px;
        
        .select {
            width: 190px;
        }

        .input-wrapper {
          width: 235px;
        }
    }

    .border-bottom {
      border-bottom: 1px solid ${props => props.theme.borderLight};
      padding-bottom: 15px;
    }
`

export const BankAdjustmentsTabs = styled.div`
  width: 340px;

  &.approved-selected {
    .react-switch-selector-wrapper::before {
      left: 2px;
    }
  }

  .react-switch-selector-wrapper {
    direction: ltr;
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    border-radius: 50px;

    &::before {
        height: calc(100% - 3px);
        width: calc(50% - 2px);
      }

    label {
      margin: 0;
    }
  }

  .react-switch-selector-option {
    padding: 9px 20px;
  }
`;

export const ActionsWrapper = styled.div`
  max-height: ${({ pending }) => pending ? '430px' : '500px'};
  overflow-Y: scroll;
  padding-inline-end: 30px;
  text-align: center;
  direction: ltr;

  .actions-pending-wrapper {
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'}
  }

  ::-webkit-scrollbar {
    width: 7px;
    background-color: #FFFFFF;
    margin: 0 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(179.97deg, #6D8FFF -24.96%, #8467FF 99.97%);
    border-radius: 25px;
  }

  .no_records {
    margin: 20px 0;
  }
`

export const ActionsCardWrapper = styled.div`
  background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
  box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
  border-radius: 25px;
  padding: 15px 30px;
  margin-top: 20px;
  width: 100%;
  height: fit-content;
  direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

  .actions-header {
    display: flex;
    justify-content: space-between;
    font-weight: 700;
    border-bottom: 1px solid rgba(216, 210, 255, 0.5);
    padding-bottom: 5px;

    div {
      display: flex;
      span {
        margin-inline-start: 20px;
      }
    }
  }

  .info-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;

    span {
      white-space: nowrap;
      margin-bottom: 0 !important;
    }

    .info-container {
      display: flex;
      flex-direction: column;

      span {
        padding: 0 !important;
      }
    }

    .info-span {
      margin-top: 7px;
      color: rgba(55, 54, 71, 0.7);
    }

    .download-button {
      display: flex;
      align-items: center;
      justify-content: center;

      .download-file {
        cursor: pointer;
      }
    }

    .description {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100px;
    }
  }
`

export const PendingActionsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;

  .pending-cards-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .question {
      width: 40px;
      cursor: pointer;
    }

    .remove-records {
      cursor: pointer;
      border-radius: 50px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--bllink-purple);
      background-color: #E9E9FD;
    }
  }

  .info-wrapper {
    font-size: 14px;
  }

  .action-with-checkbox {
    display: flex;

    .actions-header {
      font-size: 12px;
    }

    .info-wrapper {
      font-size: 11px;
    }

    .check {
      margin-inline-end: 10px;
    }

    label {
      width: 100%;
    }

    .checkboxLabel {
      margin-left: 0 !important;
      width: 100%;
    }
  } 

  .action-with-checkbox>div {
    width: 100%;
  }
  
  .drag-and-drop {
    margin-top: 20px;

    .drag-and-drop-inner-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
      box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
      border-radius: 11px 11px 0 0;
      border-bottom: 1px solid var(--bllink-purple);
      padding: 60px 30px;
      cursor: pointer;

      .drag-and-drop-header {
        font-size: 20px;
        font-weight: 700;
        margin-top: 15px;
      }
    }
  }

  .previously-uploaded-files-wrapper {
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 0 0 11px 11px;
    padding: 10px 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .previously-uploaded-file {
      display: flex;
      gap: 15px;
      cursor: pointer;
      div {
        display: flex;
        flex-direction: column;
        text-align: start;

        .size-span {
          color: rgba(55, 54, 71, 0.42);
          font-size: 13px;
        }
        
        span {
          &:first-child {
            font-weight: 700
          }
        }
      }
    }

    .no-files {
      text-align: center;
      width: 100%;
      color: var(--bllink-gray)
    }
  }
`

export const PendingFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .footer-header {
    margin: 20px 0;
    font-size: 18px;
    font-weight: 700;
  }
  .buttons-wrapper {
    display: flex;
    gap: 20px;
  }

  .buttons-wrapper .app-btn {
    height: 100%;
  }
`

export const ReconciliationModalStyled = styled(StyledModal)`
  .modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .modal-text-header {
      font-size: 25px;
      font-weight: 700;
      margin: 10px 0 25px;
    }

    label {
      span {
        text-align: center !important;
      }
    }

    .approve-btn {
      margin-top: 30px;
    }

    .card-pairs-wrapper {
      max-height: 450px;
      overflow-Y: scroll;
      
      .checkboxLabel {
        margin-bottom: 0 !important;
      }

      ::-webkit-scrollbar {
        width: 7px;
        background-color: #FFFFFF;
        margin: 0 10px;
      }
    
      ::-webkit-scrollbar-thumb {
        background: linear-gradient(179.97deg, #6D8FFF -24.96%, #8467FF 99.97%);
        border-radius: 25px;
      }
    }
  }
`

export const CardsMatchWrapper = styled.div`
  display: flex;

  .cards-match {
    display: grid;
    grid-template-columns: 450px 80px 450px;
    gap: 10px;
    align-items: center;

    .double-arrow {
      width: 80px;
    }

    .actions-header {
      font-size: 12px;
    }

    .info-wrapper {
      font-size: 11px;
    }

    .few-records-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
  }
`
